import { Bell, Mail, Send, Sparkles, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { AiSuggestionContent } from './dashboardSuggestion';

const ICONS = {
  bell: Bell,
  send: Send,
  sparkle: Sparkles,
  mail: Mail,
} as const;

export interface AiSuggestionProps extends AiSuggestionContent {
  onDismiss: () => void;
  onAccept: () => void;
}

export function AiSuggestion({
  icon = 'bell',
  title,
  body,
  actionLabel,
  onDismiss,
  onAccept,
}: AiSuggestionProps) {
  const Icon = ICONS[icon];
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-xl border border-accent/30 bg-accent-soft/40 p-4',
      )}
    >
      <button
        type="button"
        onClick={onDismiss}
        className="absolute right-3 top-3 rounded-md p-1 text-muted-foreground hover:bg-secondary hover:text-foreground"
        aria-label="Dismiss suggestion"
      >
        <X className="size-4" />
      </button>
      <div className="flex gap-3 pr-8">
        <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-accent/15 text-accent">
          <Icon className="size-5" />
        </div>
        <div className="flex flex-1 flex-col gap-2">
          <div>
            <h3 className="text-sm font-semibold text-foreground">{title}</h3>
            <p className="mt-0.5 text-sm text-muted-foreground">{body}</p>
          </div>
          <Button size="sm" className="w-fit" onClick={onAccept}>
            {actionLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
